import React from "react";
import { StatusPill } from "../Pills";
import { relativeTime } from "../../lib/format";

const RUN_STATUS_PILL = { success: "connected", error: "error" };
const runPillStatus = (s) => RUN_STATUS_PILL[s] || "stale";

/**
 * Compact list of recent SyncRun records — provider, +created/↻updated counts,
 * a relativeTime stamp and a status pill mapped from the run status.
 */
export default function SyncRunsList({ runs, providerLabels, loading }) {
  return (
    <section className="card-base overflow-hidden">
      <div className="px-5 py-3 label-tiny border-b border-border">Sync history · last {runs.length}</div>
      <div className="divide-y divide-border">
        {runs.map((r) => (
          <div key={r.id} className="px-5 py-3 flex items-center justify-between gap-3 text-sm" data-testid={`run-${r.id}`}>
            <div className="flex items-center gap-3 min-w-0">
              <span className="text-[10px] uppercase tracking-wider text-muted-foreground w-16 flex-shrink-0">{r.domain}</span>
              <span className="text-xs truncate">{providerLabels[r.provider] || r.provider || "—"}</span>
              {r.warnings?.length > 0 && <span className="text-[10px] text-[#F59E0B]">⚠ {r.warnings.length}</span>}
              {r.errors?.length > 0 && <span className="text-[10px] text-[#EF4444]">⛔ {r.errors.length}</span>}
            </div>
            <div className="flex items-center gap-3 text-[11px] font-mono">
              <span className="text-[#10B981]">+{r.rows_created || 0}</span>
              <span className="text-[#3B82F6]">↻{r.rows_updated || 0}</span>
              <span className="text-muted-foreground">{relativeTime(r.started_at)}</span>
              <StatusPill status={runPillStatus(r.status)} />
            </div>
          </div>
        ))}
        {!loading && runs.length === 0 && (
          <div className="px-5 py-10 text-center text-muted-foreground text-sm">No sync history yet.</div>
        )}
      </div>
    </section>
  );
}
